


















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class MaterialPractice1 extends Vue {
  // methods
  toPractice(subject: string): void {
    this.$router.push({path: `/practice/${subject}`, params: {subject}})
    .catch(() => {
      // @ts-ignore block is empty.
    });
  }
  toPracticeExplanation(): void {
    this.$router.push({path: '/practice/explanation'}).catch(() => {
      // @ts-ignore block is empty.
    });
  }
}
